import { render, staticRenderFns } from "./QueryRequest.vue?vue&type=template&id=97f4b2ee&"
import script from "./QueryRequest.vue?vue&type=script&lang=js&"
export * from "./QueryRequest.vue?vue&type=script&lang=js&"
import style0 from "./QueryRequest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports